module.exports = __webpack_public_path__ + "assets/cc2d8c1d4db938fa47dd9840c3771b5a.svg";